import { render, staticRenderFns } from "./ProductLimitRulesB2b.vue?vue&type=template&id=bb199eba"
import script from "./ProductLimitRulesB2b.vue?vue&type=script&lang=js"
export * from "./ProductLimitRulesB2b.vue?vue&type=script&lang=js"
import style0 from "./ProductLimitRulesB2b.vue?vue&type=style&index=0&id=bb199eba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports